// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1Kjwb","rootSmall":"AddTileButton_rootSmall__3NGEJ"};